import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import SiteLogo from './SiteLogo';
import LinksList from './Navigation/LinksList';
import LangSwitcherList from './Navigation/LangSwitchersList';
import SnsList from './Navigation/SnsList';
import * as styles from './Navigation.module.scss';
import { useStaticQuery } from 'gatsby';
var Navigation = function Navigation() {
    var _useStaticQuery = useStaticQuery("277565096"), site = _useStaticQuery.site;
    var buildDate = new Date(site.buildTime);
    var buildDateString = buildDate.toLocaleString('ja-JP');
    var buildYear = buildDate.getFullYear();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.logoBox
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/"
    }, /*#__PURE__*/ React.createElement(SiteLogo, {
        className: styles.logo
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.siteTitle
    }, "Arthur's Portfolio"), /*#__PURE__*/ React.createElement("nav", null, /*#__PURE__*/ React.createElement(LinksList, null), /*#__PURE__*/ React.createElement(LangSwitcherList, null), /*#__PURE__*/ React.createElement(SnsList, null), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("small", {
        className: styles.copyright
    }, "\xA9 2020-", buildYear, " Arthur")), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("small", {
        className: styles.copyright
    }, "Last Modified: ", buildDateString))));
};
export default Navigation;
